// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oy3Fj","toggle":"styles_toggle__1oVm-","preview":"styles_preview__2gB5G"};